import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../context/AdminProvider";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { apiService } from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { decryptStringRandomTrustedAccess } from "../../utils/encryption";
import * as jose from "jose";
import { jwtDecode } from "jwt-decode";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function LoginPage() {
  const { setMyRole } = useContext(AdminContext);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState({});
  const [isAutoLoginAttempted, setIsAutoLoginAttempted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);

  // const [rememberMe, setRememberMe] = useState(false);

  // useEffect(() => {
  //   const savedUsername = Cookies.get("username");
  //   const savedPassword = Cookies.get("password");
  //   const savedRememberMe =
  //     Cookies.get("rememberMe") == undefined || Cookies.get("rememberMe") == null ? false : Cookies.get("rememberMe");
  //   if (savedRememberMe && Boolean(savedRememberMe) && savedRememberMe != "false") {
  //     setUsername(savedUsername);
  //     setPassword(savedPassword);
  //     setRememberMe(true);
  //   }
  // }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const params = new URLSearchParams(window.location.search);
      const paramObj = {};
      for (const [key, value] of params.entries()) {
        paramObj[key] = value;
      }
      setSearchParams(paramObj);
    }
    return () => {
      isMounted = false;
    };
  }, []);

  // useEffect(() => {
  //   let isMounted = true;
  //   if (isMounted) {
  //     if (searchParams.token) {
  //       setIsLoading(true);
  //       if (executeRecaptcha && isLoading)
  //         handleLoginRedirectAutorization()
  //           .then(() => {
  //             setIsLoading(false);
  //           })
  //           .catch(() => {
  //             setIsLoading(false);
  //           });
  //     }
  //   }
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [searchParams, executeRecaptcha]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (searchParams.token) {
        setIsLoading(true);
        if (isLoading)
          handleLoginRedirectAutorization()
            .then(() => {
              setIsLoading(false);
            })
            .catch(() => {
              setIsLoading(false);
            });
      }
    }
    return () => {
      isMounted = false;
    };
  }, [searchParams]);

  const handleLoginRedirectAutorization = async () => {
    const token = searchParams.token;
    let recaptchaToken = null;
    if (!token) {
      return;
    }
    if (localStorage.hasOwnProperty("recaptcha_enable") && Number(localStorage.getItem("recaptcha_enable")) !== 0) {
      recaptchaToken = await executeRecaptcha("login");
    }

    try {
      setIsLoading(true);
      let TRUSTEDACCESS_JWT_SECRET_KEY = "";
      await apiService
        .get("initialize")
        .then((res) => res?.data || res)
        .then((response) => {
          TRUSTEDACCESS_JWT_SECRET_KEY = atob(response?.TRUSTEDACCESS_JWT_SECRET_KEY);
        })
        .catch((err) => {
          console.error(err);
        });

      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp && decoded.exp <= currentTime) {
        toast.error("Token expired");
        setIsAutoLoginAttempted(true);
        setIsLoading(false);
        return;
      }

      const encoder = new TextEncoder();
      const { payload } = await jose.jwtVerify(token, encoder.encode(TRUSTEDACCESS_JWT_SECRET_KEY));

      const decryptedUsername = await decryptStringRandomTrustedAccess(payload.username);
      const decryptedPassword = await decryptStringRandomTrustedAccess(payload.password);
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState({}, document.title, url.toString());

      let body = {
        emailId: decryptedUsername,
        password: decryptedPassword,
        token: recaptchaToken,
      };

      await apiService
        .post("authenticate/admin/login", body)
        .then((res) => res?.data || res)
        .then((response) => {
          toast.dismiss();
          if (response.resultCode > 0) {
            sessionStorage.setItem("isLogin", true);

            setMyRole(response?.data?.role || "USER");

            toast.success(response.message || "Done");

            navigate("organizations");
          } else {
            toast.error(response.message || "Fail");
          }
        })
        .catch((err) => {
          setLoading(false);
        })
        .finally(() => {});
    } catch (error) {
      console.error(`Auto-login failed:`, error);
    } finally {
      setIsLoading(false);
      console.log("RELOGIN");
      setIsAutoLoginAttempted(true);
    }
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      let recaptchaToken = null;
      if (localStorage.hasOwnProperty("recaptcha_enable") && Number(localStorage.getItem("recaptcha_enable")) !== 0) {
        recaptchaToken = await executeRecaptcha("login");
      }
      let body = {
        emailId: data.get("email"),
        password: data.get("password"),
        token: recaptchaToken,
      };

      if (!body.emailId || !body.password) {
        toast.warn("Please fill the required fields!");
        return;
      }
      toast.loading("Processing...");
      setLoading(true);

      apiService
        .post("authenticate/admin/login", body)
        .then((res) => res?.data || res)
        .then((response) => {
          toast.dismiss();
          if (response.resultCode > 0) {
            try {
              sessionStorage.setItem("isLogin", true);
              console.log("RES:", response.data, response.data?.organizations);
              setMyRole(response?.data?.role || "USER");

              toast.success(response.message || "Done");

              navigate("organizations");
            } catch (error) {
              console.error(`Login failed:`, error);
            }
          } else {
            toast.error(response.message || "Fail");
          }
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
        });

      sessionStorage.setItem("jwtToken", "success");
    } catch (error) {
      console.error(`Login failed:`, error);
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Paper elevation={3} sx={{ p: 5 }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img src="/Valydate4u.png" style={{ margin: "auto 0.5rem", width: "14rem", height: "100%" }} />
          </Box>
          <Typography component="h1" variant="h5" align="center" sx={{ my: 2 }}>
            Admin sign in
          </Typography>
          {isLoading ? (
            <Box>
              <Typography variant="body1" sx={{ mt: 2, color: "gray" }}>
                Redirection authorizing, please wait...
              </Typography>
            </Box>
          ) : (
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }} autoFocus>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                autoComplete="username"
                name="email"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              {/* <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                autoComplete="current-password"
                InputLabelProps={{ shrink: true }}
              /> */}

              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                <OutlinedInput
                  fullWidth
                  required
                  name="password"
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>

              {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <FormControlLabel
                value={rememberMe}
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => {
                      setRememberMe(e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label="Remember me"
              />
            </Box> */}

              <Button disabled={loading} type="submit" fullWidth variant="contained" sx={{ mt: 1 }}>
                Sign In
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </>
  );
}

export default LoginPage;
